module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Light.37a8daf2.ttf";